import { Component, Input } from '@angular/core';

@Component({
  selector: 'sigecom-progress-bar',
  template: `
    <div class="w-full mt-2">
      <p class="text-sm text-sigecom-dark-gray mb-1">Comprimindo imagem, aguarde a finalização para salvar. ({{ progress | number:'1.0-2' }}%)</p>
      <div class="w-full h-2 bg-gray-200 rounded overflow-hidden">
        <div class="h-full bg-sigecom-info transition-all duration-300 ease-linear"
          [style.width.%]="progress"></div>
      </div>
    </div>
  `,
})
export class ProgressBarComponent {

  @Input() progress: number = 0;

}
